import { render, staticRenderFns } from "./LiveCounts.view.vue?vue&type=template&id=0f641c42&scoped=true"
import script from "./LiveCounts.view.vue?vue&type=script&lang=ts"
export * from "./LiveCounts.view.vue?vue&type=script&lang=ts"
import style0 from "./LiveCounts.view.vue?vue&type=style&index=0&id=0f641c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f641c42",
  null
  
)

export default component.exports